// extracted by mini-css-extract-plugin
module.exports = {"connectorAuthDialogFooter":"_connectorAuthDialogFooter--2qGPl","connectorDialogContent":"_connectorDialogContent--3gnyi"};